import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Label } from '@ragu-components/ord-types';

const LabelsList = React.lazy(async () => import('./LabelsList'));

export const labelsResource: OrdResourceProps = {
  key: Resources.labels,
  name: Resources.labels,
  list: <LabelsList />,
  options: {},
  recordRepresentation: (record: Label): string => record.name,
};
